var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8746 19.9993H11.8748C11.5298 19.9993 11.2498 19.7193 11.2498 19.3743V15.6244H8.7499V19.3743C8.7499 19.7193 8.46991 19.9993 8.12492 19.9993H3.12508C2.7801 19.9993 2.50011 19.7193 2.50011 19.3743V10.6246H0.625167C0.372362 10.6246 0.144557 10.4724 0.0476855 10.2386C-0.0491864 10.0052 0.00424939 9.73648 0.183306 9.55773L9.558 0.183041C9.80174 -0.0610136 10.198 -0.0610136 10.4417 0.183041L19.8164 9.55773C19.9952 9.73648 20.0486 10.0052 19.952 10.2386C19.8552 10.4724 19.6274 10.6246 19.3746 10.6246H17.4996V19.3743C17.4996 19.7196 17.2199 19.9993 16.8746 19.9993ZM12.4998 18.7493H16.2497V9.99959C16.2497 9.6546 16.5296 9.37461 16.8746 9.37461H17.8655L9.99986 1.50893L2.13418 9.37461H3.12508C3.47007 9.37461 3.75006 9.6546 3.75006 9.99959V18.7493H7.49994V14.9994C7.49994 14.6544 7.77993 14.3744 8.12492 14.3744H11.8748C12.2198 14.3744 12.4998 14.6544 12.4998 14.9994V18.7493Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.7e6de4f2f4d23e2f5c5c983309eb81bd.svg";
export { ForwardRef as ReactComponent };